// The Tenor Splitter helper function returns a formatted array eg [1, 'D'].
// This function converts the returned period value to 'day', 'month' or 'year',
// which is the correct format to use with dayjs for further calculations
export function GetTenorPeriodFromArray(
  tenorArr: [number, string] | null
): 'day' | 'week' | 'month' | 'year' | null {
  if (tenorArr) {
    const periodLookup = {
      D: 'day',
      M: 'month',
      W: 'week',
      Y: 'year',
    };
    return periodLookup[tenorArr[1]];
  }
  return null;
}
